import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import uuid from "react-uuid";

import { makeStyles } from "@mui/styles";
import { FloatInput, TextInput } from "components/Input/Index.js";

import CreateButton from "components/CustomButtons/CreateButton.js";

import { compte } from "variables/patrimoine.js";

import AdvancedSearchContext from "context/AdvancedSearchContext";
import { ActionContext } from "context/ActionContext";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import { updateAccountContract, getFiles } from "services/ConfigServices";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      backgroundColor: '#fff',
      //width: "30ch",
    },
  },
  formControl: {
    margin: '8px',
    minWidth: 120,
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 0rem",
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
  },
  switch: {
    marginLeft: "0.5rem",
  },
}));

function AddContractDialog(props) {
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;
  const actionContext = useContext(ActionContext);
  const { action, setAction } = actionContext;

  let existingcontract = (action?.parameters?.impact?.newContract && action?.parameters?.impact?.newContract.length > 0) ? action?.parameters?.impact?.newContract[0] : {};

  const [clef, setClef] = useState(existingcontract?.details?.clef || '');
  const [contractname, setContractname] = useState(existingcontract?.details?.contractname || '');
  const [contractnumber, setContractnumber] = useState(existingcontract?.details?.contractnumber || '');
  const [tarifftype, setTarifftype] = useState(existingcontract?.details?.tarifftype || '');
  const [name, setName] = useState(existingcontract?.details?.name || '');
  const [contractbegindate, setContractbegindate] = useState(existingcontract?.details?.contractbegindate || '');
  const [contractenddate, setContractenddate] = useState(existingcontract?.details?.contractenddate || '');
  const [billowner, setBillowner] = useState(existingcontract?.details?.billowner || '');
  const [contractowner, setContractowner] = useState(existingcontract?.details?.contractowner || '');
  const [payedby, setPayedby] = useState(existingcontract?.details?.payedby || '');
  const [primaryfinalenergyratio, setPrimaryfinalenergyratio] = useState(existingcontract?.details?.primaryfinalenergyratio || '');
  const [co2ratio, setCo2ratio] = useState(existingcontract?.details?.co2ratio || '');
  const [energycost, setEnergycost] = useState(existingcontract?.details?.energycost || '');
  const [energycosthph, setEnergycosthph] = useState(existingcontract?.details?.energycosthph || '');
  const [energycosthpe, setEnergycosthpe] = useState(existingcontract?.details?.energycosthpe || '');
  const [energycosthch, setEnergycosthch] = useState(existingcontract?.details?.energycosthch || '');
  const [energycosthce, setEnergycosthce] = useState(existingcontract?.details?.energycosthce || '');
  const [energycostpointe, setEnergycostpointe] = useState(existingcontract?.details?.energycostpointe || '');
  const [energycosthp, setEnergycosthp] = useState(existingcontract?.details?.energycosthp || '');
  const [energycosthc, setEnergycosthc] = useState(existingcontract?.details?.energycosthc || '');
  const [energycostbase, setEnergycostbase] = useState(existingcontract?.details?.energycostbase || '');
  const [othermonthlycost, setOthermonthlycost] = useState(existingcontract?.details?.othermonthlycost || '');
  const [otherunitcost, setOtherunitcost] = useState(existingcontract?.details?.otherunitcost || '');
  const [comments, setComments] = useState(existingcontract?.details?.comments || '');
  const [description, setDescription] = useState(existingcontract?.details?.description || '');
  const [gedList, setGedList] = useState([
    { fileName: String, fileId: Number },
  ]);
  const [ged, setGed] = useState(existingcontract?.details?.ged || []);


  console.log(action.parameters.impact.newContract);
  const { closeModal, refetch, deleteCounter } = props;

  const handleClefChange = (e) => {
    setClef(e.target.value);
  };
  const handleContractnameChange = (e) => {
    setContractname(e.target.value);
  };
  const handleContractnumberChange = (e) => {
    setContractnumber(e.target.value);
  };
  const handleTariftypeChange = (e) => {
    setTarifftype(e.target.value);
  };
  const handleNameChange = (e) => {
    setName(e.target.value);
  };
  const handleContractbegindateChange = (e) => {
    setContractbegindate(e.target.value);
  };
  const handleContractenddateChange = (e) => {
    setContractenddate(e.target.value);
  };
  const handleBillownerChange = (e) => {
    setBillowner(e.target.value);
  };
  const handleContractownerChange = (e) => {
    setContractowner(e.target.value);
  };
  const handlePayedbyChange = (e) => {
    setPayedby(e.target.value);
  };
  const handlePrimaryfinalenergyratioChange = (e) => {
    setPrimaryfinalenergyratio(e.target.value);
  };
  const handleCo2ratioChange = (e) => {
    setCo2ratio(e.target.value);
  };
  const handleEnergycostChange = (e) => {
    setEnergycost(e.target.value);
  };
  const handleEnergycosthphChange = (e) => {
    setEnergycosthph(e.target.value);
  };
  const handleEnergycosthpeChange = (e) => {
    setEnergycosthpe(e.target.value);
  };
  const handleEnergycosthchChange = (e) => {
    setEnergycosthch(e.target.value);
  };
  const handleEnergycosthceChange = (e) => {
    setEnergycosthce(e.target.value);
  };
  const handleEnergycostpointeChange = (e) => {
    setEnergycostpointe(e.target.value);
  };
  const handleEnergycosthpChange = (e) => {
    setEnergycosthp(e.target.value);
  };
  const handleEnergycosthcChange = (e) => {
    setEnergycosthc(e.target.value);
  };
  const handleEnergycostbaseChange = (e) => {
    setEnergycostbase(e.target.value);
  };
  const handleOthermonthlycostChange = (e) => {
    setOthermonthlycost(e.target.value);
  };
  const handleOtherunitcostChange = (e) => {
    setOtherunitcost(e.target.value);
  };
  const handleAssociatedfilesChange = (newValue) => {
    setGed(newValue);
  };
  const handleCommentsChange = (e) => {
    setComments(e.target.value);
  };
  const handleDescriptionChange = (e) => {
    setDescription(e.target.value);
  };
  const selectedGed = () => {
    let gedCardId = [];
    let getGedNames;

    if (ged !== undefined) {
      for (let i = 0; i < ged.length; i++) {
        gedCardId.push(ged[i].fileId);
      }
      getGedNames = gedList.filter((gedList) =>
        gedCardId.includes(gedList.fileId)
      );
    }
    return getGedNames;
  };

  useEffect(() => {
    axios
      .get(getFiles(chartIdGroup), {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((res) => {
        setGedList(res.data.collection);
      });
  }, []);

  const handleSubmit = async (event) => {
    const editedDetails = {
      clef,
      contractname,
      contractnumber,
      tarifftype,
      name,
      contractbegindate,
      contractenddate,
      billowner,
      contractowner,
      payedby,
      primaryfinalenergyratio,
      co2ratio,
      energy: targetedenergy,
      energycosthph,
      energycosthpe,
      energycosthch,
      energycosthce,
      energycostpointe,
      energycosthp,
      energycosthc,
      energycostbase,
      othermonthlycost,
      otherunitcost,
      comments,
      description,
      ged,
    };

    if (targetedenergy !== "electricity") {
      editedDetails.energycost = energycost;
    } else if (targetedenergy == "electricity") {
      editedDetails.energycosthph = energycosthph;
      editedDetails.energycosthpe = energycosthpe;
      editedDetails.energycosthch = energycosthch;
      editedDetails.energycosthce = energycosthce;
      editedDetails.energycostpointe = energycostpointe;
      editedDetails.energycosthp = energycosthp;
      editedDetails.energycosthc = energycosthc;
      editedDetails.energycostbase = energycostbase;
    }

    const editedContract = {
      uuid: uuid(),
      isSelected: true,
      details: editedDetails,
    };

    let meters = action.parameters?.impact?.meters;

    meters.map((m) => (m.details.newContract = editedContract.uuid));

    setAction((prevState) => ({
      ...prevState,
      parameters: {
        ...prevState.parameters,
        impact: {
          ...prevState.parameters?.impact,
          meters,
          newContract: [editedContract],
        },
      },
    }));
    closeModal();
  };

  const [targetedenergy, setTargetedenergy] = useState(
    action.parameters?.impact?.energy
  );
  // const handleTargetedenergyChange = (e) => {
  //   setTargetedenergy(e.target.value);
  // };

  const energy = targetedenergy;
  const parameters = "utilities";

  const classes = useStyles();

  return (
    <div>
      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <TextInput
              inputTitle={compte.energy[energy][parameters].contractname}
              textInput={contractname}
              handleTextInputChange={handleContractnameChange}
              isRequired
            />
            <TextInput
              inputTitle={compte.energy[energy][parameters].name}
              textInput={name}
              handleTextInputChange={handleNameChange}
            />

            <FloatInput
              inputTitle={
                compte.energy[energy][parameters].primaryfinalenergyratio
              }
              floatInput={primaryfinalenergyratio}
              handleFloatInputChange={handlePrimaryfinalenergyratioChange}
            />

            <FloatInput
              inputTitle={compte.energy[energy][parameters].co2ratio}
              floatInput={co2ratio}
              handleFloatInputChange={handleCo2ratioChange}
            />
            {targetedenergy !== "electricity" && (
              <>
                <FloatInput
                  inputTitle={compte.energy[energy][parameters].energycost}
                  floatInput={energycost}
                  handleFloatInputChange={handleEnergycostChange}
                />
                <FloatInput
                  inputTitle={compte.energy[energy][parameters].othermonthlycost}
                  floatInput={othermonthlycost}
                  handleFloatInputChange={handleOthermonthlycostChange}
                />
              </>
            )}

            {targetedenergy == "electricity" && (
              <>
                <FloatInput
                  inputTitle={compte.energy[energy][parameters].energycosthph}
                  floatInput={energycosthph}
                  handleFloatInputChange={handleEnergycosthphChange}
                />

                <FloatInput
                  inputTitle={compte.energy[energy][parameters].energycosthpe}
                  floatInput={energycosthpe}
                  handleFloatInputChange={handleEnergycosthpeChange}
                />

                <FloatInput
                  inputTitle={compte.energy[energy][parameters].energycosthch}
                  floatInput={energycosthch}
                  handleFloatInputChange={handleEnergycosthchChange}
                />

                <FloatInput
                  inputTitle={compte.energy[energy][parameters].energycosthce}
                  floatInput={energycosthce}
                  handleFloatInputChange={handleEnergycosthceChange}
                />

                <FloatInput
                  inputTitle={
                    compte.energy[energy][parameters].energycostpointe
                  }
                  floatInput={energycostpointe}
                  handleFloatInputChange={handleEnergycostpointeChange}
                />

                <FloatInput
                  inputTitle={compte.energy[energy][parameters].energycosthp}
                  floatInput={energycosthp}
                  handleFloatInputChange={handleEnergycosthpChange}
                />

                <FloatInput
                  inputTitle={compte.energy[energy][parameters].energycosthc}
                  floatInput={energycosthc}
                  handleFloatInputChange={handleEnergycosthcChange}
                />

                <FloatInput
                  inputTitle={compte.energy[energy][parameters].energycostbase}
                  floatInput={energycostbase}
                  handleFloatInputChange={handleEnergycostbaseChange}
                />
                <FloatInput
                  inputTitle={compte.energy[energy][parameters].otherunitcost}
                  floatInput={otherunitcost}
                  handleFloatInputChange={handleOtherunitcostChange}
                />
                <FloatInput
                  inputTitle={
                    compte.energy[energy][parameters].othermonthlycost
                  }
                  floatInput={othermonthlycost}
                  handleFloatInputChange={handleOthermonthlycostChange}
                />


              </>
            )}
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <CreateButton buttonDisabled={!contractname} handleSubmit={handleSubmit} />
          </GridItem>
          <GridItem xs={12} sm={6} md={5} lg={5}></GridItem>
        </GridContainer>
      </form>
    </div>
  );
}

export default AddContractDialog;
